import React from 'react';
import styles from './styles.less';

interface GfqlRawEditorProps {
  gfqlString: string;
  onGfqlChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  gfqlError: string;
}

export const GfqlRawEditor: React.FC<GfqlRawEditorProps> = ({
  gfqlString,
  onGfqlChange,
  gfqlError
}) => {
  return (
    <div className={styles['gfql-editor-container']}>
      <div className={styles['gfql-editor-header']}>
        <label htmlFor="set-gfql-editor">Query (GFQL)</label>
        <a href="/docs/GFQL/gfql-predicates/" target="_blank" rel="noopener noreferrer" className={styles['help-link']}>
          Need Help?
        </a>
      </div>
      <textarea
        id="set-gfql-editor"
        className={styles['gfql-editor']}
        value={gfqlString}
        onChange={onGfqlChange}
        rows={8}
        placeholder="Enter GFQL query in JSON format"
      />
      {gfqlError && <div className={styles['gfql-error']}>{gfqlError}</div>}
    </div>
  );
};
